import {
  FormField,
  FormFieldList,
  SfCheckboxComponent,
  SfCheckboxFormField,
  SfSelectOption,
  SfToggleFormField,
} from 'ngx-smart-form';
import {
  CmsField,
  MappedCmsSection,
  ICmsField,
  MappedCmsSectionWithFields,
  MappedCmsSectionWithFieldList,
} from '../../_core/models/cms-field';
import { Product } from './product';
import { SfAddressField } from '../../_core/models/sf-address-field';

export interface CmsFinanziamenti {
  data: {
    financings: {
      data: {
        id: string;
        attributes: {
          type: string;
          target: string;
          crif: {
            sprint: string;
            description: string;
            eu: string;
            node: string;
          };
          maxAmount: string;
          minAmount: string;
          sections: ICmsField[];
          ateco: { code: string; description: string }[];
        };
      }[];
    };
  };
}

export interface CmsFinanziamento {
  data: {
    financings: {
      data: [
        {
          attributes: {
            type: string;
            target: string;
            crif: {
              sprint: string;
              description: string;
              eu: string;
              node: string;
            };
            maxAmount: string;
            minAmount: string;
            maxDuration: number;
            sections: ICmsField[];
            ateco: { code: string; description: string }[];
          };
        }
      ];
    };
  };
}

export class Finanziamenti {
  static getProductOptions(data?: CmsFinanziamenti) {
    const options: (SfSelectOption & {
      ateco: { code: string; description: string }[];
    })[] =
      data?.data.financings.data.map((el) => ({
        value: el.attributes.type,
        view: el.attributes.type,
        ateco: el.attributes.ateco,
      })) || [];
    return options;
  }

  static getFields<T>(
    sections: ICmsField[],
    item: T | undefined,
    hasExtendedValue: boolean = false
  ) {
    let mappedSections: MappedCmsSectionWithFields[] = [];
    for (let i = 0; i < sections.length; i++) {
      let s = sections[i];
      mappedSections.push({
        title: s.title || '',
        subtitle: s.subtitle || '',
        description: s.description || '',
        type: s.type || '',
        fields: [],
      });
      if (!s.type) {
        continue;
      }
      let fields: FormField[] = [];
      for (let j = i; j < sections.length; j++) {
        let internalSection = sections[j];
        if (internalSection.type) {
          let field = CmsField.genField(
            internalSection,
            item,
            hasExtendedValue
          );
          if (field) {
            fields.push(field);
          }
          if (j === sections.length - 1 || !sections[j].type) {
            mappedSections[mappedSections.length - 1].fields.push(...fields);
            i = j;
            break;
          }
        } else {
          mappedSections[mappedSections.length - 1].fields.push(...fields);
          i = j - 1;
          break;
        }
      }
    }
    let pageSections: MappedCmsSectionWithFieldList[] = mappedSections.map(
      (s) => {
        let sliced: FormFieldList = [];
        for (let i = 0; i < s.fields.length; i++) {
          let slice = s.fields.slice(i, i + 2);
          /* if (
            this.isStandaloneField(slice[0]) ||
            this.isStandaloneField(slice[1])
          ) {
            slice.pop();
            sliced.push(slice);
          } else { */
          sliced.push(slice);
          i = i + slice.length - 1;
          //}
        }
        let pageSection: MappedCmsSectionWithFieldList = {
          title: s.title,
          description: s.description,
          fields: sliced,
          subtitle: s.subtitle,
          type:
            sliced[0]?.[0] instanceof SfAddressField ? 'ADDRESS' : 'DEFAULT',
        };
        return pageSection;
      }
    );
    return pageSections;
  }

  static isStandaloneField(field: FormField) {
    return (
      field instanceof SfToggleFormField || field instanceof SfCheckboxFormField
    );
  }
}
